window.addEventListener('load', function () {
  const entrySubmitForm = document.getElementById('recruit_entry_submit_form')
  const submitButton = document.getElementById('recruit_entry_submit');
  let isSubmitted = false;

  ////////////////////////////
  // イベント
  ////////////////////////////
  if (entrySubmitForm !== null) {
    entrySubmitForm.addEventListener('submit', function (event) {
      if (isSubmitted) {
        event.preventDefault();
        return;
      }

      submitButton.disabled = true;
      isSubmitted = true;
    });
  }
});
